var _defs, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoData01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 432.7 337.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#cad2f9;}.cls-2{fill:#6e7fdd;}.cls-3{fill:#eb725f;}.cls-4{letter-spacing:0em;}.cls-5,.cls-6{fill:#fff;}.cls-7{fill:#eef4ff;}.cls-8{fill:#e3ebfc;}.cls-6{font-family:Arial-BoldMT, Arial;font-size:11.5px;font-weight:700;}.cls-9{fill:#b6c3f2;}.cls-10{fill:none;}.cls-11{letter-spacing:0em;}.cls-12{letter-spacing:.1em;}.cls-13{fill:#f5f9ff;}.cls-14{clip-path:url(#clippath-1);}.cls-15{fill:#edf0fc;}.cls-16{fill:#0046a0;opacity:0;}.cls-17{fill:#8397ed;}.cls-18{opacity:.2;}.cls-19{fill:#e2e6ff;}.cls-20{fill:#d0dbf7;}.cls-21{fill:#f9ab43;}.cls-22{fill:#f4aea6;}.cls-23{clip-path:url(#clippath);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M359.7,310.6s-31.2-63.3,64-90.9c0,0,6.6,95.9-64,90.9Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M76.8,303.9s-55.3,13.2-60.1-66.2c0,0,76.5,11.9,60.1,66.2Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "432.7 99.7 426.2 99.7 426.2 93.2 421.5 93.2 421.5 99.7 414.9 99.7 414.9 104.4 421.5 104.4 421.5 111 426.2 111 426.2 104.4 432.7 104.4 432.7 99.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "397.9 204.2 392.1 204.2 392.1 198.4 387.9 198.4 387.9 204.2 382.1 204.2 382.1 208.3 387.9 208.3 387.9 214.2 392.1 214.2 392.1 208.3 397.9 208.3 397.9 204.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "148.9 36.5 143.1 36.5 143.1 30.7 138.9 30.7 138.9 36.5 133.1 36.5 133.1 40.6 138.9 40.6 138.9 46.5 143.1 46.5 143.1 40.6 148.9 40.6 148.9 36.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "421.9 129.5 417.7 129.5 417.7 125.2 414.7 125.2 414.7 129.5 410.5 129.5 410.5 132.5 414.7 132.5 414.7 136.7 417.7 136.7 417.7 132.5 421.9 132.5 421.9 129.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "129.9 62.1 125.7 62.1 125.7 57.9 122.7 57.9 122.7 62.1 118.4 62.1 118.4 65.1 122.7 65.1 122.7 69.3 125.7 69.3 125.7 65.1 129.9 65.1 129.9 62.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "19.1 113.1 13.2 113.1 13.2 107.2 9.1 107.2 9.1 113.1 3.3 113.1 3.3 117.2 9.1 117.2 9.1 123 13.2 123 13.2 117.2 19.1 117.2 19.1 113.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "21.2 294.9 17 294.9 17 290.6 14 290.6 14 294.9 9.7 294.9 9.7 297.9 14 297.9 14 302.1 17 302.1 17 297.9 21.2 297.9 21.2 294.9"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 9.7,
    cy: 210.1,
    r: 3.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M425.1,166.4c0,1.1-.9,2.1-2.1,2.1s-2.1-.9-2.1-2.1.9-2.1,2.1-2.1,2.1.9,2.1,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M423.5,296.4c0,2.2-1.8,3.9-3.9,3.9s-3.9-1.8-3.9-3.9,1.8-3.9,3.9-3.9,3.9,1.8,3.9,3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M148.5,2.1c0,1.1-.9,2.1-2.1,2.1s-2.1-.9-2.1-2.1.9-2.1,2.1-2.1,2.1.9,2.1,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M105.3,4.6c0,2.2-1.8,3.9-3.9,3.9s-3.9-1.8-3.9-3.9,1.8-3.9,3.9-3.9,3.9,1.8,3.9,3.9Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 176.6,
    cy: 14.6,
    r: 3.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M4.1,149.4c0,1.1-.9,2.1-2.1,2.1s-2.1-.9-2.1-2.1.9-2.1,2.1-2.1,2.1.9,2.1,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M43.1,217.6c0,1.1-.9,2.1-2.1,2.1s-2.1-.9-2.1-2.1.9-2.1,2.1-2.1,2.1.9,2.1,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M415,58.1c0,1.1-.9,2.1-2.1,2.1s-2.1-.9-2.1-2.1.9-2.1,2.1-2.1,2.1.9,2.1,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M338.1,20.4c0,1.1-.9,2.1-2.1,2.1s-2.1-.9-2.1-2.1.9-2.1,2.1-2.1,2.1.9,2.1,2.1Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 369.3,
    cy: 8.4,
    r: 3.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M431.8,276.7c0,1.1-.9,2.1-2.1,2.1s-2.1-.9-2.1-2.1.9-2.1,2.1-2.1,2.1.9,2.1,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M62.1,8.5c0,1.1-.9,2.1-2.1,2.1s-2.1-.9-2.1-2.1.9-2.1,2.1-2.1,2.1.9,2.1,2.1Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 213.2,
    cy: 319,
    rx: 209.9,
    ry: 18.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M359.7,310.6s-31.2-63.3,64-90.9c0,0,6.6,95.9-64,90.9Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M436.4,234.4l-.5-.9c-18.8,11.2-35.9,15.1-41,16.1,4.7-5.6,9.4-10.7,13.6-15.1,1.9-.4,14.9-3,28-12.8l-.6-.8c-11.1,8.3-22,11.4-26.1,12.3,9.1-9.5,15.9-15.5,16.1-15.7l-.7-.8c-.2.2-7.1,6.3-16.4,16,.9-12.1,6.8-23.9,6.9-24l-1-.5c0,.1-6.5,13-7.1,25.7-4.2,4.4-8.9,9.5-13.6,15.1.3-15.8,7.1-34.3,7.2-34.5l-1-.4c0,.2-7.3,19.9-7.2,36.1-4.6,5.4-9.1,11.3-13.4,17.4-.8-22.7,5.9-46.2,6-46.4l-1-.3c0,.2-7.1,24.8-5.9,48.2-3.2,4.6-6.1,9.3-8.8,14-4.7-24.4,1.4-46.6,1.4-46.8l-1-.3c0,.2-6.4,23.4-1.2,48.6-2.6,4.8-4.9,9.6-6.6,14.4-6-17.1-7.2-41.6-6.9-43l-1-.2c-.3,1.5.8,27.1,7.4,44.7-1.6,4.6-2.8,9.2-3.3,13.6h1.1c.5-4.2,1.6-8.6,3.2-13,1.2.3,4.8.9,11,.9s1,0,1.5,0c8-.1,21.4-1.3,40.2-6.4l-.3-1c-32,8.7-48.8,6.2-52,5.6,1.8-4.9,4.1-10,6.8-14.9.9,0,3.1.3,6.3.3,10.2,0,30.4-1.8,47.8-14.3l-.6-.9c-21.9,15.6-48.1,14.3-53,13.8,2.7-4.9,5.8-9.8,9.1-14.5,3.3-.3,32.5-3.7,52-18.9l-.7-.8c-18,14.1-44.6,17.8-50.5,18.5,4.3-6.2,9-12.1,13.6-17.6,2.5-.4,21.5-3.9,42.6-16.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M423.6,219.7c-5.6,1.6-10.8,3.4-15.6,5.3,2.1,6.2,3.2,12.8,3.2,19.8,0,31.6-23.2,57.2-51.9,57.2s-1.8,0-2.7,0c1.4,5.4,3,8.8,3,8.8,70.6,5,64-90.9,64-90.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M76.8,303.9s-55.3,13.2-60.1-66.2c0,0,76.5,11.9,60.1,66.2Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M30.6,230.3l-.8.3c5.5,16.7,5.5,30.8,5.4,35-3.5-4.7-6.7-9.2-9.4-13.3,0-1.5.2-12.2-5.1-24.2l-.8.3c4.5,10.1,5,19.2,5.1,22.6-5.8-8.8-9.4-15.2-9.5-15.4l-.7.4c.1.2,3.7,6.7,9.7,15.7-9.3-2.8-17.5-9.6-17.6-9.7l-.5.7c0,0,9,7.4,18.9,10.1,2.7,4.1,5.9,8.6,9.5,13.3-12.3-3.1-25.7-11.6-25.8-11.7l-.5.7c.1,0,14.3,9.2,27.1,12.1,3.5,4.5,7.3,9.2,11.3,13.6-18-3.4-35.2-12.8-35.4-12.9l-.4.7c.2,0,18.2,10,36.8,13.2,3,3.3,6.2,6.5,9.5,9.4-20-.7-36.4-9.3-36.5-9.4l-.4.8c.2,0,17.2,9.2,38,9.6,3.3,2.9,6.7,5.5,10.1,7.7-14.5,1.7-33.9-1.8-35-2.2l-.3.8c1.2.5,21.4,4.2,36.5,2.1,3.3,2.1,6.7,3.8,10.1,5l.3-.8c-3.3-1.2-6.5-2.8-9.8-4.8.4-.9,1.5-3.6,2.6-8.5,0-.4.2-.8.3-1.2,1.3-6.3,2.7-17,2.1-32.6h-.9c1.1,26.7-3.8,39.4-4.8,41.8-3.6-2.3-7.1-5-10.5-8,.2-.7.8-2.4,1.3-4.9,1.8-8,4-24.1-2.7-40l-.8.3c8.4,20,2.7,40.2,1.5,44-3.4-3-6.6-6.3-9.8-9.7.3-2.6,2.9-26.1-5.6-44.1l-.8.4c7.8,16.6,6.1,38.1,5.6,42.9-4.1-4.5-7.9-9.2-11.4-13.8.1-2,.7-17.5-5.4-36.3Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M16.7,237.7c.3,4.7.8,9.1,1.4,13.1,5.2-.5,10.6-.2,16.1,1,24.8,5.6,40.8,28.3,35.7,50.8-.2.7-.3,1.4-.5,2.1,4.5-.1,7.4-.8,7.4-.8,16.5-54.4-60.1-66.2-60.1-66.2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 55.3,
    y: 80.1,
    width: 315.6,
    height: 196.6,
    rx: 8,
    ry: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 64.2,
    y: 89.8,
    width: 297.8,
    height: 177.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 164.2,
    y: 276.7,
    width: 98,
    height: 24.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M309.1,315.3c-17.9-14.5-54.1-24.4-95.9-24.4s-78,9.9-95.9,24.4h191.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M117.3,317.8h184c2.5,0,5,0,7.5,0,.1,0,.2,0,.3,0,3.2,0,3.2-5,0-5H125.1c-2.5,0-5,0-7.5,0-.1,0-.2,0-.3,0-3.2,0-3.2,5,0,5h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 80.5,
    y: 102.1,
    width: 265.3,
    height: 153.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 80.5,
    y: 102.1,
    width: 265.3,
    height: 14.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M93.4,109.8c0,1.9-1.5,3.4-3.4,3.4s-3.4-1.5-3.4-3.4,1.5-3.4,3.4-3.4,3.4,1.5,3.4,3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M104.8,109.8c0,1.9-1.5,3.4-3.4,3.4s-3.4-1.5-3.4-3.4,1.5-3.4,3.4-3.4,3.4,1.5,3.4,3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M116.2,109.8c0,1.9-1.5,3.4-3.4,3.4s-3.4-1.5-3.4-3.4,1.5-3.4,3.4-3.4,3.4,1.5,3.4,3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M306.9,181.7c0,9.1-7.9,16.6-17.5,16.6h-147.6c-9.6,0-17.5-7.5-17.5-16.6s7.9-16.6,17.5-16.6h147.6c9.6,0,17.5,7.5,17.5,16.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M160.9,189.6l-6.1-5.6c.9-1.3,1.4-2.8,1.3-4.5,0-1.9-.9-3.7-2.3-5.1-1.4-1.3-3.3-2-5.2-1.9-1.9,0-3.7.9-5.1,2.3-1.3,1.4-2,3.3-1.9,5.2,0,1.9.9,3.7,2.3,5.1,1.4,1.3,3.3,2,5.2,1.9,1.6,0,3.1-.6,4.3-1.6l6.1,5.6,1.3-1.4ZM145.3,183.6c-1-1-1.6-2.3-1.7-3.7,0-1.4.5-2.8,1.4-3.8,1-1,2.3-1.6,3.7-1.7,1.4,0,2.8.5,3.8,1.4h0c1,1,1.6,2.3,1.7,3.7,0,1.4-.5,2.8-1.4,3.8-1,1-2.3,1.6-3.7,1.7-1.4,0-2.8-.5-3.8-1.4Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 187.2,
    cy: 181.5,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 207.2,
    cy: 181.5,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 227.2,
    cy: 181.5,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 247.2,
    cy: 181.5,
    r: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 272.8,
    y: 42.2,
    width: 132,
    height: 145.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 272.8,
    y: 42.2,
    width: 132,
    height: 16.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M287.1,50.8c0,2.1-1.7,3.7-3.7,3.7s-3.7-1.7-3.7-3.7,1.7-3.7,3.7-3.7,3.7,1.7,3.7,3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M299.7,50.8c0,2.1-1.7,3.7-3.7,3.7s-3.7-1.7-3.7-3.7,1.7-3.7,3.7-3.7,3.7,1.7,3.7,3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M312.3,50.8c0,2.1-1.7,3.7-3.7,3.7s-3.7-1.7-3.7-3.7,1.7-3.7,3.7-3.7,3.7,1.7,3.7,3.7Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 384,
    y: 125.9,
    width: 7.7,
    height: 69.1,
    transform: "translate(.1 321.2) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 362.6,
    y: 132.3,
    width: 14.5,
    height: 20.2,
    transform: "translate(7.6 303.2) rotate(-45)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M363.4,136c-12.8,12.8-33.6,12.8-46.4,0s-12.8-33.6,0-46.4c12.8-12.8,33.6-12.8,46.4,0,12.8,12.8,12.8,33.6,0,46.4Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M366.5,139.1c-14.5,14.5-38.1,14.5-52.6,0s-14.5-38.1,0-52.6c14.5-14.5,38.1-14.5,52.6,0,14.5,14.5,14.5,38.1,0,52.6ZM319.3,92c-11.5,11.5-11.5,30.2,0,41.7s30.2,11.5,41.7,0,11.5-30.2,0-41.7c-11.5-11.5-30.2-11.5-41.7,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "356.5 101.3 351.7 96.5 340.2 108 328.7 96.5 323.9 101.3 335.4 112.8 323.9 124.3 328.7 129.1 340.2 117.6 351.7 129.1 356.5 124.3 345 112.8 356.5 101.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "129.8 210.1 70 210.1 70 318 162.2 318 162.2 241.1 129.8 210.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "129.8 210.1 162.2 241.1 129.8 241.1 129.8 210.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M106.3,251.5c0,3.2-1.9,5.9-4.2,5.9s-4.2-2.6-4.2-5.9,1.9-5.9,4.2-5.9,4.2,2.6,4.2,5.9Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 130,
    cy: 251.5,
    rx: 4.2,
    ry: 5.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M104.3,269.1c1.7-1.9,4.2-3.4,6.6-4.3,6.1-2.2,12,0,16.7,4.3,1.2,1.1,3.1-.7,1.8-1.8-5.2-4.6-11.9-7.4-18.8-5.1-3,1-6.1,2.8-8.2,5.1-1.1,1.2.7,3.1,1.8,1.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M98.3,28.1H31.1c-4,0-7.3,3.3-7.3,7.3v47.1c0,4,3.3,7.3,7.3,7.3h23.6l10,12.2,10-12.2h23.6c4,0,7.3-3.3,7.3-7.3v-47.1c0-4-3.3-7.3-7.3-7.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M64.7,36.9c-12.3,0-22.3,10-22.3,22.2s10,22.3,22.3,22.3,22.3-10,22.3-22.3-10-22.2-22.3-22.2ZM64.7,41.1c4.2,0,8.1,1.5,11.2,3.9l-25.3,25.3c-2.4-3.1-3.9-7-3.9-11.2,0-10,8.1-18.1,18.1-18.1ZM64.7,77.2c-4.2,0-8.1-1.5-11.2-3.9l25.3-25.3c2.4,3.1,3.9,7,3.9,11.2,0,10-8.1,18.1-18.1,18.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "349.1 217.6 293.3 217.2 292.7 317.9 378.6 318.5 379.1 246.8 349.1 217.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "349.1 217.6 379.1 246.8 348.9 246.6 349.1 217.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "354.2 255.1 348.9 249.8 336 262.5 323.3 249.6 317.9 254.9 330.6 267.8 317.8 280.5 323.1 285.9 336 273.2 348.7 286.1 354.1 280.7 341.3 267.9 354.2 255.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "68.1 140 34.7 123.2 4.6 183.5 56 209.3 77.5 166.4 68.1 140"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "68.1 140 77.5 166.4 59.4 157.3 68.1 140"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "60.1 164 58.5 159.2 47 163 43.2 151.5 38.4 153.1 42.2 164.6 30.7 168.5 32.3 173.3 43.8 169.4 47.6 180.9 52.4 179.3 48.6 167.8 60.1 164"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "192.8 28.1 166.2 36.8 181.8 85 223 71.6 211.8 37.3 192.8 28.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "192.8 28.1 211.8 37.3 197.4 42 192.8 28.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "201.3 45.2 197.9 43.5 193.7 51.6 185.6 47.5 183.9 50.9 192 55 187.9 63.2 191.3 64.9 195.4 56.8 203.5 60.9 205.3 57.5 197.1 53.4 201.3 45.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M275.3,23.5h-2.3c-.5-2.1-1.3-4-2.4-5.8l1.7-1.6c1.3-1.3,1.3-3.4,0-4.7l-1.9-1.9c-1.3-1.3-3.4-1.3-4.7,0l-1.7,1.6c-1.8-1.1-3.7-1.9-5.8-2.4v-2.3c0-1.8-1.5-3.3-3.3-3.3h-2.7c-1.8,0-3.3,1.5-3.3,3.3v2.3c-2.1.5-4,1.3-5.8,2.4l-1.6-1.7c-1.3-1.3-3.4-1.3-4.7,0l-1.9,1.9c-1.3,1.3-1.3,3.4,0,4.7l1.6,1.7c-1.1,1.8-1.9,3.7-2.4,5.8h-2.3c-1.8,0-3.3,1.5-3.3,3.3v2.7c0,1.8,1.5,3.3,3.3,3.3h2.3c.5,2.1,1.3,4,2.4,5.8l-1.7,1.6c-1.3,1.3-1.3,3.4,0,4.7l1.9,1.9c1.3,1.3,3.4,1.3,4.7,0l1.7-1.6c1.8,1.1,3.7,1.9,5.8,2.4v2.3c0,1.8,1.5,3.3,3.3,3.3h2.7c1.8,0,3.3-1.5,3.3-3.3v-2.3c2.1-.5,4-1.3,5.8-2.4l1.6,1.7c1.3,1.3,3.4,1.3,4.7,0l1.9-1.9c1.3-1.3,1.3-3.4,0-4.7l-1.6-1.7c1.1-1.8,1.9-3.7,2.4-5.8h2.3c1.8,0,3.3-1.5,3.3-3.3v-2.7c0-1.8-1.5-3.3-3.3-3.3ZM253.4,37.4c-5.1,0-9.2-4.2-9.2-9.3,0-5.1,4.2-9.2,9.3-9.2,5.1,0,9.2,4.2,9.2,9.3,0,5.1-4.2,9.2-9.3,9.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M253.5,14.9c-7.3,0-13.2,5.9-13.3,13.2,0,7.3,5.9,13.2,13.2,13.3,7.3,0,13.2-5.9,13.3-13.2,0-7.3-5.9-13.2-13.2-13.3ZM253.4,36.3c-4.5,0-8.2-3.7-8.2-8.2,0-4.5,3.7-8.2,8.2-8.2,4.5,0,8.2,3.7,8.2,8.2,0,4.5-3.7,8.2-8.2,8.2Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "TEXTS"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(89.5 288.8)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 0,
    y: 0
  }, "NO D"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 33.3,
    y: 0
  }, "AT"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 49.2,
    y: 0
  }, "A")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData01);
export default __webpack_public_path__ + "static/media/no-data.01.19bf4547f570a748bf088fa9656fc4dd.svg";
export { ForwardRef as ReactComponent };